import React from 'react'
import VideoFirst from './VideoFirst'
import VideoSecond from './VideoSecond'
import VideoThird from './VideoThird'
import ContactSection from './ContactSection'
// import ContactForm from './ContactForm'

const VideoDevelopmentPage = () => {
  return (
    <div>
      <VideoFirst/>
      <VideoSecond/>
      <VideoThird/>
      <ContactSection />
      {/* <ContactForm /> */}
    </div>
  )
}

export default VideoDevelopmentPage
